import { render, staticRenderFns } from "./tabs-swift.vue?vue&type=template&id=53f5c7d0&scoped=true&"
import script from "./tabs-swift.vue?vue&type=script&lang=js&"
export * from "./tabs-swift.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/tab/_tab-swift.scss?vue&type=style&index=0&id=53f5c7d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f5c7d0",
  null
  
)

export default component.exports